<template>
  <div>
    <van-nav-bar
      class="backBox"
      title="签退成功"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="content_box">
      <div class="signOk">
        <div class="img">
          <img src="../../assets/imgs/signOutOk.png" alt="" />
        </div>
        <span class="title">签退成功!请带好您的随身物品！</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  },
  mounted () {

  },
  computed: {

  },
  methods: {
    onClickLeft () {
      this.$router.replace('/order')
    }

  }
}
</script>
<style scoped lang="scss">
.content_box {
  padding: 1rem;
}
.signOk {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
}
.img {
  width: 13.4375rem;
  height: 11.5625rem;
}
.img img {
  width: 100%;
  height: 100%;
}
.title {
  margin-top: 2rem;
}
</style>
